"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("../../actions/ReadinessCheck/types");
function sandboxMeetingSession() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  if (action.type === "".concat(_types.BROADCAST_CREATE_SANDBOX_MEETING, "_SUCCESS")) {
    return action.payload;
  }
  if (action.type === "".concat(_types.BROADCAST_REMOVE_SANDBOX_MEETING, "_SUCCESS")) {
    return null;
  }
  return state;
}
var _default = exports["default"] = sandboxMeetingSession;